var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('BudgetPageToolbar',{attrs:{"j":"","title":_vm.$capitalize(_vm.$tc('model.products_repair_title')),"back-to":_vm.productPage,"new-to":_vm.newVersionPage,"version-route-name":"ProductReparationData","budget-versions":_vm.reparations}})],1)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }